import $ from 'jquery'

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'confirm'
const DATA_KEY = `opp.${NAME}`
const EVENT_KEY = '.' + DATA_KEY
const JQUERY_NO_CONFLICT = $.fn[NAME]

const Selector = {
  DATA_ACCEPT: '[data-accept="confirm"]',
  DATA_DISMISS: '[data-dismiss="confirm"]'
}

export const Event = {
  SHOW: 'show' + EVENT_KEY,
  CLICK_ACCEPT: 'click.accept' + EVENT_KEY,
  CLICK_DISMISS: 'click.dismiss' + EVENT_KEY,
  HIDE_BS_MODAL: 'hide.bs.modal'
}

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Confirm {
  constructor(element) {
    this._element = element
    this._isShown = false
  }

  // Public

  show(accepted, dismissed) {
    if (this._isShown) {
      return
    }

    // Create "show" event with `accept` and `dismiss` methods.
    const showEvent = $.Event(Event.SHOW, {
      accept() {
        this.preventDefault()
        accepted()
      },
      dismiss() {
        this.preventDefault()
        dismissed()
      }
    })

    // Trigger "show" event and return if cancelled.
    $(this._element).trigger(showEvent)
    if (showEvent.isDefaultPrevented()) {
      return
    }

    // Actually show the confirm modal and listen for clicks

    this._isShown = true

    $(this._element).on(
      Event.CLICK_ACCEPT,
      Selector.DATA_ACCEPT,
      () => this.hide(accepted)
    )

    $(this._element).on(
      Event.CLICK_DISMISS,
      Selector.DATA_DISMISS,
      () => this.hide(dismissed)
    )

    $(this._element).on(
      Event.HIDE_BS_MODAL,
      () => this.hide(dismissed)
    )

    $(this._element).modal('show')
  }

  hide(done) {
    if (!this._isShown) {
      return
    }

    this._isShown = false

    $(this._element).off(Event.CLICK_ACCEPT)
    $(this._element).off(Event.CLICK_DISMISS)

    $(this._element).modal('hide')

    if (done) {
      done()
    }
  }

  // Static

  static chain({ accept, dismiss, elements, step: _step }) {
    const [head, ...tail] = elements || []

    if (head) {
      const step = _step || (x => this.chain(x))
      const next = () => step({ accept, dismiss, elements: tail, step })
      this._jQueryInterface.call($(head), 'show', next, dismiss)
    } else if (accept) {
      accept()
    }
  }

  static _jQueryInterface(config, ...args) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)

      if (!data) {
        data = new Confirm(this)
        $(this).data(DATA_KEY, data)
      }

      if (typeof config === 'string') {
        if (typeof data[config] === 'undefined') {
          throw new TypeError(`No method named "${config}"`)
        }

        data[config](...args)
      }
    })
  }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = Confirm._jQueryInterface
$.fn[NAME].Constructor = Confirm
$.fn[NAME].noConflict = () => {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return Confirm._jQueryInterface
}

export default Confirm
